import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Practices from "@/components/Practices";
import WhyChoose from "@/components/WhyChoose";
import Services from "@/components/Services";
import Vision from "@/components/Vision";
import Clients from "@/components/Clients";
import Footer from "@/components/Footer";

export default function Home() {
    return (
        <main className="relative min-h-screen bg-white" data-testid="home-page">
            <Navbar />
            <Hero />
            <About />
            <Practices />
            <WhyChoose />
            <Services />
            <Vision />
            <Clients />
            <Footer />
        </main>
    );
}
